import { Theme } from '@logto/schemas';
import type { Branding } from '@logto/schemas';
import type { Nullable } from '@silverhand/essentials';

import allguthLogo from '@/shared/assets/allguth-logo.png';

// Allguth ships a single bundled logo for tenant branding; the tenant-configured
// branding logo is ignored so the sign-in UI always shows the Allguth mark. This does
// not apply to per-connector logos (e.g. Apple/Google), which must render as configured.

export type GetLogoUrl = {
  theme: Theme;
  logoUrl: string;
  darkLogoUrl?: Nullable<string>;
};

export const getLogoUrl = ({ theme, logoUrl, darkLogoUrl }: GetLogoUrl) =>
  theme === Theme.Dark ? (darkLogoUrl ?? logoUrl) : logoUrl;

export type GetBrandingLogoUrl = {
  theme: Theme;
  branding: Branding;
  isDarkModeEnabled: boolean;
};

export const getBrandingLogoUrl = (_args: GetBrandingLogoUrl) => allguthLogo;
